import { defaultClauseStatus } from "./constants";
import { PromptManagementValidations } from "./Pages/constants";

export const getClauseItemsForContractReview = (clause: string) => {
  const items = clause
    .split("\n")
    .map((item) => item.trim())
    .filter((item) => item);

  let data = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i].split(":");
    const name: any = item[0].trim();
    const number = item[1].trim();
    const parsedNumber = parseFloat(number);
    const subclauses = Object.values(
      PromptManagementValidations.CONTRACT_REVIEW
    );
    const rulesObjects = subclauses.map((subclause: any) => subclause?.rules);
    let ruleKeys = [];
    let rulesObj: any = {};
    for (let idx = 0; idx < rulesObjects.length; idx++) {
      const rule = rulesObjects[idx];
      for (let [key, val] of Object.entries(rule)) {
        ruleKeys.push(key);
        rulesObj = { ...rulesObj, [key]: val };
      }
    }
    const itemData = {
      name: name,
      count: parsedNumber,
      ...rulesObj?.[name],
    };
    data.push(itemData);
  }
  return data;
};

export const getRuleForSavingForContractReview = (
  rules: { name: string; count: number; unit: string }[]
) => {
  let str = "";
  rules?.forEach((rule) => {
    str += rule?.name + ": " + rule?.count + rule?.unit + "\n";
  });
  return str;
};

export const getRefinedValuePerUnit = (
  item: any,
  val: any,
  isDefaultVal: boolean
) => {
  switch (item?.unit) {
    case "%":
      if (val > 100) {
        val = 100;
      }
      break;
    case "$":
      break;
    default:
      break;
  }
  return isDefaultVal ? item?.count : val;
};

export const getClauseItemsForTTC = (clause: string) => {
  const items = clause
    .split("\n")
    .map((item) => item.trim())
    .filter((item) => item);

  let values = [];
  for (let i = 0; i < items.length; i++) {
    const keyValPair = items[i].split(":");
    const key = keyValPair[0].trim();
    const val = keyValPair[1].trim();
    const synonyms = val.replace(/['"]+/g, "").split(/\s*,\s*/);
    values.push({
      [key]: key === "Word" ? synonyms[0] : synonyms,
      type: defaultClauseStatus.DEFAULT,
    });
  }

  const clubbedValues = [];
  for (let i = 0; i < values.length - 1; i += 2) {
    const item = values[i];
    const val = values[i + 1];
    const obj = {
      ...item,
      ...val,
    };

    clubbedValues.push(obj);
  }

  return clubbedValues;
};

export const getRuleForSavingForTTC = (
  rules: { Word: string; Synonyms: string[]; type: string }[]
) => {
  let str = "";
  rules?.forEach((rule) => {
    str += "Word: " + `"${rule?.Word}"` + "\n";
    str += "Synonyms: ";
    rule?.Synonyms?.forEach((synonym, idx) => {
      str += `"${synonym}" `;
      if (idx !== rule?.Synonyms?.length - 1) {
        str += ", ";
      }
    });
    str += "\n\n";
  });
  return str;
};
